import reward1 from "../Assets/images/New/Offer1.jpg";
import reward2 from "../Assets/images/New/Offer2.jpg";
import reward3 from "../Assets/images/New/Offer3.jpg";
import reward4 from "../Assets/images/New/Offer4.jpg";
import reward5 from "../Assets/images/New/Offer5.jpg";
import reward6 from "../Assets/images/New/Offer6.jpg";
const data = [
  {
    id: "1",
    image: reward1,
    title: "3 Assignment",
    description: "30% On",
    next: "Next Order",
  },
  {
    id: "2",
    image: reward2,
    title: "5 Assignment",
    description: "2 Movie",
    next: "Tickets",
  },
  {
    id: "3",
    image: reward3,
    title: "10 Assignment",
    description: "Next 1",
    next: "Assignment Free",
  },
  {
    id: "4",
    image: reward4,
    title: "20 Assignment",
    description: "40% On",
    next: "Next 3 Order",
  },
  {
    id: "5",
    image: reward5,
    title: "40 Assignment",
    description: "Extra Cash",
    next: "Bonus of $100",
  },
  {
    id: "6",
    image: reward6,
    title: "50 Assignment",
    description: "Extra Cash",
    next: "Bonus of $100",
  },
];

const termCondition = [
  "Minimum Amount of order of each assignment will be valued at - $40",
  "For only Assignments asked and when payment received then only",
  "For Assignments which fulfill the criteria of DoubtQ",
  "This Redeemable criteria can be updated or change by DoubtQ anytime without any consent",
];

export { data, termCondition };